import { render } from "./InvoicePayments.vue?vue&type=template&id=2a920d2e&scoped=true"
import script from "./InvoicePayments.vue?vue&type=script&lang=js"
export * from "./InvoicePayments.vue?vue&type=script&lang=js"

import "./InvoicePayments.vue?vue&type=style&index=0&id=2a920d2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a920d2e"]])

export default __exports__